import React, { useState, useEffect } from "react";
// import {
//   FieldValue,
//   firefunctions,
// } from "../../../components/firebase/FirebaseProvider";
// import { useData } from "../../../components/firebase/DataProvider";
import { useSnackbar } from "notistack";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Countdown from "react-countdown";
import useStyles from "./style";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Skeleton from "@material-ui/lab/Skeleton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { DialogTitle, Divider } from "@material-ui/core";
import Gap from "../../../../components/Gap";
import {
  FieldValue,
  firefunctions,
} from "../../../../components/firebase/FirebaseProvider";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import currency from "../../../../utils/currency";
import { useData } from "../../../../components/firebase/DataProvider";

const SkeletonLoader = () => {
  const data = [1, 2, 3, 4, 5, 6];
  const classes = useStyles();

  return (
    <>
      {data.map((item, index) => (
        <Grid className={classes.wrapVoucher}>
          <Card variant="outlined" className={classes.cardVoucher}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="rect" width={50} height={50} />
            </div>
            <Gap width={15} />
            <div style={{ width: "100%" }}>
              <Skeleton width="50%" />
              <Skeleton width="40%" />
              <Skeleton width="10%" />
            </div>
          </Card>
        </Grid>
      ))}
    </>
  );
};

function ListVoucher({
  open,
  handleClose,
  handleBatalkan,
  handleChange,
  form,
  error,
  loading,
  handleSubmit,
  subcart,
  alamatId,
  cartRef,
}) {
  const classes = useStyles();
  const { voucherData } = useData();

  const [data, setData] = useState([]);
  const [pilihVoucher, setPilihVoucher] = useState(
    subcart?.inpoin ? subcart?.inpoin : {}
  );
  const [loadingDialog, setLoadingDialog] = useState(false);
  const [loadingHandle, setLoadingHandle] = useState(false);
  const theme = useTheme();

  const matches1 = useMediaQuery(theme.breakpoints.up("705"));

  const getData = async () => {
    setLoadingDialog(true);
    try {
      const funcList = await firefunctions.httpsCallable("inpoin-myVoucher")();
      const claim = funcList?.data?.data?.filter((a) => a.Status == "Claim");
      setData(claim ?? []);
      setLoadingDialog(false);
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            const func = firefunctions.httpsCallable("inpoin-login");
            const data = {};
            await func(data);
            setLoadingDialog(false);
          } catch (error) {
            setData([]);
            setLoadingDialog(false);
            console.log("- loginInpoin", error);
          }
        };
        loginInpoin();
      }
      setData([]);
      setLoadingDialog(false);
      console.log("- listVoucher", error.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAddVoucher = async (item) => {
    try {
      setLoadingHandle(true);
      if (item.Status == "Claim" && !subcart.promo_voucher) {
        cartRef.set(
          {
            subcarts: {
              [alamatId]: {
                inpoin: item,
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
      }
      setLoadingHandle(false);
      handleClose();
    } catch (error) {
      console.log("-handleAddVoucher", error);
      setLoadingHandle(false);
    }
  };

  const handleReset = () => {
    try {
      cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              inpoin: FieldValue.delete(),
              nilai_voucher: FieldValue.delete(),
              promo_voucher: FieldValue.delete(),
              // total_tagihan_before_vouher: FieldValue.delete(),
            },
          },
          updated_at: FieldValue.serverTimestamp(),
        },
        { merge: true }
      );
      setPilihVoucher({});
    } catch (error) {
      console.log(error.message);
    }
  };

  const Renderer = ({ days }) => {
    return (
      <div
        style={{
          border: "1px solid #5675D3",
          borderRadius: 4,
          backgroundColor: "#DEE4F7",
          padding: "12px",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <div style={{ marginRight: 8, alignSelf: "center" }}>
          <InfoOutlinedIcon color="primary" />
        </div>
        <div style={{ marginTop: "3px" }}>
          <Typography
            color="primary"
            style={{
              fontSize: 13,
              color: "#5675D3",
            }}
          >
            Kode voucher "{voucherData?.[0]?.nama}" Hanya berlaku{" "}
            {days === 0
              ? "hingga hari ini"
              : days === 1
              ? "hingga besok"
              : `${days} lagi`}
            . Yuk pakai sebelum kehabisan.
          </Typography>
        </div>
      </div>
    );
  };

  const handleKembali = () => {
    handleClose();
    if (!subcart?.inpoin) {
      setPilihVoucher({});
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={handleKembali}
          />
          <Typography
            style={{ fontWeight: "bold", marginLeft: "20px", fontSize: "20px" }}
          >
            Pilih Voucher
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 10 }}>
        <List>
          <ListItem style={{ padding: 0, paddingBottom: 10 }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={form?.nama?.length > 0 ? 9 : 12}>
                <TextField
                  fullWidth
                  id="nama"
                  name="nama"
                  label="Kode voucher"
                  variant="outlined"
                  size="small"
                  color="primary"
                  disabled={loading || subcart?.promo_voucher}
                  value={form?.nama?.toUpperCase() || ""}
                  error={error.nama ? true : false}
                  helperText={error.nama}
                  onChange={handleChange}
                />
              </Grid>
              <Grid
                item
                xs={3}
                style={{ display: form?.nama?.length > 0 ? "block" : "none" }}
              >
                <Button
                  style={{ textTransform: "capitalize" }}
                  onClick={
                    subcart?.promo_voucher ? handleBatalkan : handleSubmit
                  }
                  fullWidth
                  color={subcart?.promo_voucher ? "secondary" : "primary"}
                  size="medium"
                  variant="contained"
                >
                  {loading ? (
                    <CircularProgress size={20} />
                  ) : subcart?.promo_voucher ? (
                    "Batalkan"
                  ) : (
                    "Gunakan"
                  )}
                </Button>
              </Grid>
              {voucherData[0]?.show && (
                <Grid item xs={12}>
                  <Countdown
                    date={voucherData[0]?.end_at?.toMillis()}
                    renderer={Renderer}
                  />
                </Grid>
              )}
            </Grid>
          </ListItem>
        </List>
        <Divider style={{ margin: "0px -10px" }} />
        <Gap height={20} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography className={classes.liquidVocherPrimary}>
              Voucher saya
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loadingDialog ? (
              <SkeletonLoader />
            ) : data?.length > 0 ? (
              data?.map((item) => {
                const status = pilihVoucher?.reference === item?.reference;
                return (
                  <Grid className={classes.wrapVoucher}>
                    <Card
                      variant="outlined"
                      style={{
                        backgroundColor: status ? "#EDF1FF" : "#FFF",
                        borderColor: status ? "#7072AF" : "#D0D4E0",
                      }}
                    >
                      <CardActionArea onClick={() => setPilihVoucher(item)}>
                        <div className={classes.cardVoucher}>
                          <div className={classes.wrapThumb}>
                            <img
                              alt={item?.name}
                              src={item?.image}
                              className={classes.thumb}
                            />
                          </div>
                          <Gap width={15} />
                          <div>
                            <Typography className={classes.liquidVocherPrimary}>
                              {item?.name}
                            </Typography>
                            <Typography
                              className={classes.liquidVocherSecondary}
                            >
                              {item?.category}
                            </Typography>
                            <Typography
                              className={classes.liquidVocherSecondary}
                            >
                              {item?.description.slice(0, 70)}...
                            </Typography>
                          </div>
                        </div>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "75px",
                  borderRadius: 8,
                  marginBottom: "20px",
                  padding: "10px",
                  backgroundColor: "gainsboro",
                }}
              >
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    fontSize: 14,
                    // marginTop: "2.5%",
                    fontWeight: "bold",
                  }}
                >
                  Voucher Kosong
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
        {pilihVoucher.reference || subcart?.promo_voucher ? (
          <div className={classes.boxButton}>
            <div className={classes.buttonSelect}>
              <div>
                <Typography className={classes.liquidVocherSecondary}>
                  Kamu hemat
                </Typography>
                <Typography
                  className={classes.liquidPrimaryliquidVocherSecondary}
                >
                  {currency(pilihVoucher?.coin ?? 0)}
                </Typography>
              </div>
            </div>
            <div
              className={
                !subcart?.promo_voucher
                  ? classes.buttonSelect1
                  : classes.buttonSelect
              }
              onClick={() => handleAddVoucher(pilihVoucher)}
            >
              <h2
                style={{
                  fontFamily: "revert",
                  color: subcart?.promo_voucher ? "#C9C5C5" : "#FFF",
                  fontSize: matches1 ? 16 : 15,
                }}
              >
                {loadingHandle ? <CircularProgress size={20} /> : "Gunakan"}
              </h2>
            </div>
          </div>
        ) : (
          ""
        )}
      </DialogContent>
    </Dialog>
  );
}

function Voucher({
  alamatId,
  subcart,
  cartRef,
  getDataVoucher,
  checkProductSyarat,
  loadDebounce,
  loadDelivery,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [loading, setloading] = useState(false);
  const { profil } = useData();
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState({
    nama: "",
  });
  const [error, setError] = useState({
    nama: "",
  });
  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.type === "number") {
      value = parseInt(value);
    }
    setForm({
      ...form,
      [e.target.name]: value,
    });

    setError({
      ...error,
      [e.target.name]: "",
    });
  };

  useEffect(() => {
    setForm({
      nama: subcart?.promo_voucher,
    });
  }, [subcart?.promo_voucher]);

  useEffect(() => {
    if (subcart?.resi_otomatis_mp) {
      if (subcart?.inpoin?.category == "ongkir") {
        cartRef.set(
          {
            subcarts: {
              [alamatId]: {
                inpoin: FieldValue.delete(),
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
        enqueueSnackbar("Voucher tidak  bisa di gunakan", { variant: "error" });
      }
    }
  }, [subcart?.resi_otomatis_mp, subcart?.inpoin?.category]);

  const validate = async () => {
    const newError = { ...error };

    if (!form.nama) {
      newError.nama = "Kode Voucher harus di isi";
    }

    return newError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const findError = await validate();
    if (Object.values(findError).some((m) => m !== "")) {
      setError(findError);
    } else {
      setloading(true);
      try {
        const datas = await getDataVoucher(
          form?.nama?.toUpperCase(),
          profil?.id
        );

        const check_quota = datas?.quota - (datas?.quota_used ?? 0);
        if (datas === undefined) {
          setError({ nama: "Voucher tidak ditemukan" });
          setForm({ nama: "" });
        } else if (check_quota < 1) {
          setError({ nama: "Voucher telah habis" });
          setForm({ nama: "" });
        } else if (datas?.location === "webstore") {
          setError({ nama: "Voucher tidak bisa digunakan" });
        } else if (datas?.status === "inactive") {
          setError({ nama: "Voucher tidak aktif" });
          setForm({ nama: "" });
        } else if (subcart?.total_tagihan < datas?.min_transaksi) {
          setError({
            nama: `Tambah ${currency(
              Math.round(datas?.min_transaksi - subcart?.total_tagihan)
            )} untuk menggunakan voucher`,
          });
          setForm({ nama: "" });
        } else if (subcart?.resi_otomatis_mp && datas.kategori === "ongkir") {
          enqueueSnackbar(
            "voucher tidak berlaku untuk pemakaian resi otomatis marketplace",
            {
              variant: "error",
            }
          );
        } else if (subcart?.inpoin) {
          enqueueSnackbar("hanya bisa menggunakan 1 voucher", {
            variant: "error",
          });
        } else if (
          datas?.syarat &&
          !checkProductSyarat(
            datas?.syarat?.tipe,
            datas?.syarat?.min_transaksi,
            subcart?.total_tagihan_harga_normal,
            datas?.syarat?.min_produk,
            datas?.syarat?.products,
            subcart?.products
          )
        ) {
          setError({ nama: "Voucher tidak bisa digunakan" });
        } else {
          if (
            (datas.status === "active" && check_quota < 1) ||
            datas?.location === "sellerapp" ||
            (datas?.location === "all" && !subcart?.inpoin)
          ) {
            let isHarganormal = datas?.harga_normal
              ? {
                  nilai_voucher_before: datas?.voucher,
                }
              : "";
            cartRef.set(
              {
                subcarts: {
                  [alamatId]: {
                    promo_voucher: datas?.nama?.toUpperCase(),
                    ...isHarganormal,
                    kategori_voucher: datas?.kategori
                      ? datas?.kategori
                      : "produk",
                  },
                },
                updated_at: FieldValue.serverTimestamp(),
              },
              { merge: true }
            );
          }
          enqueueSnackbar("Voucher berhasil digunakan", {
            variant: "success",
          });
          setDialog(false);
        }
        // });
        setloading(false);
      } catch (e) {
        setloading(false);

        console.log(e.message);
      }
    }
  };

  const handleBatalkan = async (e) => {
    e.preventDefault();
    let isHarganormal = subcart?.nilai_voucher_before
      ? {
          nilai_voucher_before: FieldValue.delete(),
        }
      : "";
    try {
      await cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              nilai_voucher: FieldValue.delete(),
              kategori_voucher: FieldValue.delete(),
              promo_voucher: FieldValue.delete(),
              ...isHarganormal,
            },
          },
          updated_at: FieldValue.serverTimestamp(),
        },
        { merge: true }
      );
      enqueueSnackbar("Voucher dihapus", { variant: "error" });
      setForm({ nama: "" });
      setDialog(false);
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <>
      <List>
        <ListItem>
          <Button
            className={classes.btnVoucher}
            disableRipple
            disabled={loadDebounce || loadDelivery}
            onClick={() => setDialog(true)}
          >
            <ConfirmationNumberOutlinedIcon color="primary" />
            {subcart?.inpoin || subcart?.promo_voucher ? (
              <div style={{ display: "inline-grid", marginLeft: "20px" }}>
                <span style={{ color: "black", marginRight: "auto" }}>
                  {subcart?.inpoin?.name
                    ? subcart?.inpoin?.name
                    : "Tokorame Voucher"}
                </span>
                <span style={{ color: "#5675D3", marginRight: "auto" }}>
                  Hemat{" "}
                  {currency(
                    subcart?.inpoin?.coin
                      ? subcart?.inpoin?.coin
                      : !subcart?.nilai_voucher_before
                      ? subcart?.nilai_voucher
                      : subcart?.nilai_voucher_before
                  )}
                </span>
              </div>
            ) : (
              <span className={classes.txtNote}>Voucher Tokorame</span>
            )}
          </Button>
        </ListItem>
      </List>
      <ListVoucher
        open={dialog}
        handleClose={() => setDialog(false)}
        form={form}
        error={error}
        handleBatalkan={handleBatalkan}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        subcart={subcart}
        loading={loading}
        alamatId={alamatId}
        cartRef={cartRef}
      />
    </>
  );
}

export default Voucher;
